import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export type ToastMarginClass = "right-toolbar-open" | "right-toolbar-close";

export interface SoftWarningToastEvent {
  readonly message: string;
  readonly marginClass: ToastMarginClass;
}

@Injectable({ providedIn: "root" })
export class ApplicationEventsFacade {
  private readonly downloadToastSubject = new BehaviorSubject<unknown>(null);
  private readonly downloadProgressSubject = new BehaviorSubject<unknown>(null);
  private readonly softWarningToastSubject =
    new BehaviorSubject<SoftWarningToastEvent | null>(null);
  private readonly sharedDataSubject = new BehaviorSubject<unknown>(null);

  readonly downloadToastEvents$ = this.downloadToastSubject.asObservable();
  readonly downloadProgress$ = this.downloadProgressSubject.asObservable();
  readonly softWarningToastEvents$ =
    this.softWarningToastSubject.asObservable();
  readonly sharedData$ = this.sharedDataSubject.asObservable();

  showDownloadToast(event: unknown): void {
    this.downloadToastSubject.next(event);
  }

  setDownloadProgress(progress: unknown): void {
    this.downloadProgressSubject.next(progress);
  }

  showSoftWarning(message: string, marginClass: ToastMarginClass): void {
    this.softWarningToastSubject.next({ message, marginClass });
  }

  setSharedData(value: unknown): void {
    this.sharedDataSubject.next(value);
  }
}
